<div class="text-center">
    <h2>Follow Ups ({{view.total}})</h2>
</div>

<div>
    <kendo-grid [data]="view"
                [pageSize]="state.take"
                [skip]="state.skip"
                [sort]="state.sort"
                [filter]="state.filter"
                [sortable]="true"
                [pageable]="{
                    pageSizes: pageSizes
                }"
                [filterable]="true"
                (dataStateChange)="dataStateChange($event)">
        <kendo-grid-span-column>
            <kendo-grid-column field="customerName" title="Name" width="50"></kendo-grid-column>
            <kendo-grid-column field="customerCode" title="Code" width="50"></kendo-grid-column>

            <ng-template kendoGridCellTemplate let-dataItem>
                <!--<a (click)="openCustomerProfile(dataItem.customerCode)">{{dataItem.customerName}} <br /> {{dataItem.customerCode}}</a>-->
                <a href="/#/customer-detail/{{dataItem.customerCode}}" target="_blank">{{dataItem.customerName}} <br /> {{dataItem.customerCode}}</a>
            </ng-template>
        </kendo-grid-span-column>
        <kendo-grid-column field="followUpDate" title="Date" filter="date" format="{0:d}" width="120">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.followUpDate | date:'shortDate'}}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="createdByEmployeeName" title="Created By" width="60">
            <!--<ng-template kendoGridCellTemplate let-dataItem>
                {{getEmployeeName(dataItem.createdByEmployeeID)}}
            </ng-template>-->
        </kendo-grid-column>
        <kendo-grid-column field="assignedToEmployeeName" title="Assigned To" width="60">
            <ng-template kendoGridCellTemplate let-dataItem>
                <kendo-dropdownlist *showRolesIf="'CRM Admin'"
                                    [data]="employees"
                                    [textField]="'fullName'"
                                    [valueField]="'employeeId'"
                                    [valuePrimitive]="true"
                                    [(ngModel)]="dataItem.assignedToEmployeeID"
                                    (valueChange)="repSet(dataItem, $event)"
                                    (selectionChange)="repChanged(dataItem, $event)"></kendo-dropdownlist>
                <span *hideRolesIf="'CRM Admin'">{{dataItem.assignedToEmployeeName}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="details" title="Details" width="500"></kendo-grid-column>
        <kendo-grid-command-column width="60">
            <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
                <button kendoGridEditCommand type="button" [primary]="true" style="margin-bottom: 5px;" *ngIf="dataItem.opportunitySalesCycleMapID < 1"
                        (click)="openCustomerStatusDialog(dataItem.customerID, dataItem.customerStatusID, dataItem.customerActionID)">Edit Status</button>
                <button class="k-button k-primary k-grid-edit-command" *ngIf="dataItem.opportunitySalesCycleMapID > 0" type="button"
                        (click)="openSalesCycleDialog(dataItem.opportunitySalesCycleMapID, dataItem.customerActionID)">Edit Opportunity</button>
            </ng-template>
        </kendo-grid-command-column>
    </kendo-grid>
</div>